module.exports = __webpack_public_path__ + "static/media/Carbon-Capture-Utilization-and-Storage.d8acda7f.svg";